<!--
 * @Author: DY
 * @Date: 2024-12-05 16:52:54
 * @LastEditTime: 2025-03-25 14:32:18
 * @Description: 柴油领用审核
 * @FilePath: \ShiMo_Mobile\src\views\storage\dieselFuelRequisitionApproval\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="dieselFuelRequisitionApproval commonListStyles">
            <van-nav-bar left-arrow left-text="应用" :style="`height: ${ $getNavHeight() }px;`" @click-left="swiperright">
                <template #title>
                    <div :class="{'active': listType == 1}" @click="listSwitch(1)">
                        待审核
                    </div>
                    <div :class="{'active': listType == 2}" @click="listSwitch(2)">
                        已审核
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">柴油出库单号：{{ item.outstock_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status_str }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_36@2x.png" alt="">
                                            <span>车牌号：{{ item.car_license }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>管理部门：{{ item.manage_dept_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>柴油代码：{{ item.material_code }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>申请时间：{{ item.creation_time }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="listType == 1">
                                            <button @click="editApply(item, 'edit')">
                                                审核
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button @click="editApply(item, 'see')">
                                                查看
                                            </button>
                                        </template>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'diesel-fuel-requisition-approval',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'diesel-fuel-requisition-approval');
        }
        next();
    },
    data() {
        return {
            tableCode: 'outstock_oil_check_app',
            listType: 1,
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
    },
    mounted() {},
    methods: {
        // 待办已办切换
        listSwitch(type) {
            if (type === 1) {
                this.tableCode = 'outstock_oil_check_app';
            } else if (type === 2) {
                this.tableCode = 'outstock_oil_checked_app';
            }
            this.pageIndex = 0;
            this.listData = [];
            this.listType = type;
            this.finished = false;
            this.initPage();
        },

        editApply(item, type) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'dieselFuelRequisitionApprovalForm', params: { type, data: item } });
        },
    },
};
</script>
<style lang="stylus">
.dieselFuelRequisitionApproval
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    section
        .van-pull-refresh
            height: calc(100% - 44rpx) !important
</style>
